import AbsModule from '../common/AbsModule';
import { GAME_AREA_MAP } from '../common/const';
import { AREA_TYPE, COUNTRY_CODE } from '../common/const';

export default class ServiceList extends AbsModule {
    getGameList(pOption = {}) {
        const defaultOption = {
            area: AREA_TYPE.NCK,
            country: COUNTRY_CODE.KR
        };
        const option = {...defaultOption, ...pOption};
        const { area, country } = option;
        const gameList = GAME_AREA_MAP[area];

        if(area === AREA_TYPE.NCK) {
            const filterList = gameList.reduce((acc, cur, idx) => {
                const countryItem = Array.isArray(cur?.country) ? cur?.country.filter(v => v === country || v?.name === country)[0] : null;
                const isCountryItemObject = countryItem && typeof countryItem === 'object';

                if(!!countryItem) {
                    // 국가별로 l10nKey값이 다를 때
                    if(isCountryItemObject && countryItem?.l10nKey) {
                        cur = {...cur, l10nKey: countryItem?.l10nKey};
                    }

                    // 국가별로 정렬 순서가 다를 때
                    const arrIndex = isCountryItemObject && countryItem?.index >= 0 ? countryItem?.index : idx;
                    if(!!acc[arrIndex]) {
                        acc.splice(arrIndex, 0, cur);
                    } else {
                        acc[arrIndex] = cur;
                    }
                }

                return acc;
            }, []);

            return filterList.filter(v => v); // empty 제거
        }

        return gameList;
    }

    makeMarkup() {
        const { l10nData, rcDash, country, isNct, isNcj, isNcaEnUs, isNcaEnGb, isNcaDe, isNcaFr } = this.com || {};
        const { area, serviceList } = this.moduleData || {};
        const { isServiceShow, isGamesShow, services } = serviceList || {};
        const isOtherArea = isNct || isNcj | isNcaEnUs | isNcaEnGb | isNcaDe | isNcaFr;
        const isRc = !!rcDash;
        const gameList = this.getGameList({ area, country }) || [];

        return `
        <div class="ncc-ncservice">
            <ul class="ncc-ncservice-list">
                ${!isServiceShow? '': `
                <li class="ncc-ncservice-item ncc-ncservice-item-plaync">
                    ${services?.Plaync?.isShow?`
                    <a href="${services?.Plaync?.url}" class="plaync"><span>${isOtherArea ? l10nData?.Service[`${area}Potal`] : l10nData?.Service["Plaync"]}</span></a>
                    `:``}
                    ${services?.NShop?.isShow?`
                    <a href="${services?.NShop?.url}" class="nshop"><span>${l10nData?.Service["NShop"]}</span></a>
                    `:``}
                </li>
                `}
                
                ${!isGamesShow || gameList?.length === 0 ? '': `
                <li class="ncc-ncservice-item ncc-ncservice-item-games">
                    <div class="ncc-ncservice-item-games-title">${isOtherArea ? l10nData?.Service[`${area}Games`] : l10nData?.Service?.Games}</div>
                    <ul>
                    ${gameList.map( (item, idx) => {
                        return `
                        <li class="">
                            <a href="${isRc && item?.urlRc ? item.urlRc : item?.url}">
                                <span class="ncc-ncservice-item-games__name">${l10nData.Service[item?.l10nKey]}</span>
                                <span class="ncc-ncservice-item-games__icon">
                                ${item?.app?.indexOf('pc')<0?``:`
                                    <span class="icon-official">Official Website</span>
                                `}
                                ${item?.app?.indexOf('apple')<0?``:`
                                    <span class="icon-apple">Apple Itunes</span>
                                `}
                                ${item?.app?.indexOf('android')<0?``:`
                                    <span class="icon-google">Google Play</span>
                                `}
                                ${item?.app?.indexOf('console')<0?``:`
                                    <span class="icon-console">Console Play</span>
                                `}
                                ${item?.app?.indexOf('nintendo')<0?``:`
                                    <span class="icon-nintendo">nintendo Play</span>
                                `}
                                ${item?.app?.indexOf('steam')<0?``:`
                                    <span class="icon-steam">steam Play</span>
                                `}
                                </span>
                            </a>
                        </li>`;
                    }).join('\n ')}
                    </ul>
                </li>
                `}

            </ul>
        </div>
        `;
    }
}